import sysConfig from '@/../config/sysConfig'
import path from 'path'
import store from '@/vuex/store'
import {hasPermission} from "../../../common/permission";

const userTypeKey = sysConfig.userInfoKeys.userTypes
// 超级管理员
export function sp_admin(userType) {
  return userType === userTypeKey.sp_admin
}
// 管理员
export function admin(userType) {
  return userType === userTypeKey.admin
}
// 运营商
export function operator(userType) {
  return userType === userTypeKey.operator
}
// 潜在运营商
export function pot_operator(userType) {
  return userType === userTypeKey.pot_operator
}
// 集团
export function group(userType) {
  return userType === userTypeKey.group
}
// 充电用户
export function consumer(userType) {
  return userType === userTypeKey.consumer
}
// 场站人员
export function station(userType) {
  return userType === userTypeKey.station
}

/**
 * 从角色对象上取名称（兼容 MyBatis Map 大小写）
 */
function getRoleName(item) {
  if (!item) {
    return ''
  }
  return String(item.name || item.NAME || item.roleName || item.role_name || '').trim()
}

/**
 * 合伙人企业的场站管理：仅支持充小兽小程序，禁止登录合伙人平台
 * 仅在有明确证据时拦截，避免误伤正常合伙人账号：
 * - 小程序 partner 为场站类（非 0/1/-1）
 * - 或角色名含「场站管理」
 */
export function isMiniProgramOnlyRole(userDetail, appPartner, appRoleName) {
  if (appPartner != null && appPartner !== '' && !isNaN(Number(appPartner))) {
    const partner = Number(appPartner)
    // 0=普通用户 1=合伙人 -1=特殊；其它为场站管理等小程序角色
    if (partner !== 0 && partner !== 1 && partner !== -1) {
      return true
    }
  }
  if (appRoleName && String(appRoleName).indexOf('场站管理') !== -1) {
    return true
  }
  if (!userDetail) {
    return false
  }
  const roles = userDetail.roleDetails
  if (roles && roles instanceof Array && roles.length > 0) {
    return roles.some(item => {
      const name = getRoleName(item)
      return name.indexOf('场站管理') !== -1
    })
  }
  const roleName = getRoleName(userDetail) || String(userDetail.roleName || '').trim()
  if (roleName.indexOf('场站管理') !== -1) {
    return true
  }
  return false
}

  // 运营商
export function operatorRole(roles) {
    return roles.includes(54)
  }

function handleGenerateRoutes(routes, permissions, basePath = '/', type = 1) {
  const res = []

  if (routes && routes instanceof Array && routes.length > 0) {
    for (const route of routes) {
      if (!route.hidden && route.meta) {
        const isLink = route.extra && route.extra.isLink
        const data = {
          path: path.resolve(basePath, route.path),
          title: route.meta.title,
          permission: route.meta.perms,
          disabled: isLink || !hasPermission(permissions, route),
          type: type
        }

        if (route.children) {
          data.children = handleGenerateRoutes(route.children, permissions, data.path, type + 1)
        }
        res.push(data)
      }
    }
  }

  return res
}

export function generateRoutes(permissions = store.getters.permissions, routes = store.getters.permission_routes) {
  return handleGenerateRoutes(routes, permissions)
}



// WEBPACK FOOTER //
// ./src/module/systemManagement/util/user.js